// @flow

import ko from 'rgs-knockout';

import 'ko-component-file-upload2';

import { FileUploadInputViewModel } from './js/model';
import template from './templates/template.html';

ko.components.register('file-upload-input', {
	viewModel: FileUploadInputViewModel,
	template: template(),
});
